import { render } from "./AddCounselorView.vue?vue&type=template&id=539d2ef4&scoped=true"
import script from "./AddCounselorView.vue?vue&type=script&lang=js"
export * from "./AddCounselorView.vue?vue&type=script&lang=js"

import "./AddCounselorView.vue?vue&type=style&index=0&id=539d2ef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539d2ef4"]])

export default __exports__